<a class="breadcrumb__link last-item" [routerLink]="[item.url]" *ngIf="!isLast">
  {{ item.label | translate }}
</a>

<span class="breadcrumb__link " *ngIf="isLast && item.label !== 'DASHBOARD.TITLE'">{{ item.label | translate }}</span>
<div class="dashboard-settings" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" *ngIf="isLast && item.label === 'DASHBOARD.TITLE'">
  <span class="breadcrumb__link" >{{ item.label | translate }}</span>
<!--  <button class="button button&#45;&#45;icon"><mat-icon svgIcon="dashboard-settings"></mat-icon></button>-->
</div>
